import TeacherDetail from './TeacherDetail'

const TeacherDetailPage = () => {
  return <TeacherDetail />
}

export default TeacherDetailPage 